// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Scribe_toggle__Ac3En"};